interface props {
	active: any;
	payload: any;
	label: any;
	labels: any;
}

const CustomTooltip: React.FC<props> = ({ active, payload, label, labels }) => {
	const getPhase = (label: any) => {
		if (labels[label]) return labels[label].phaseName;
		return "";
	};

	const getVaues = (payload: any) => {
		//console.log(payload);
		let result = payload.map((el: any, idx: any) => (
			<span
				key={idx}
				style={{
					color: el.stroke !== "#fff" ? el.stroke : el.fill,
					paddingRight: "10px",
				}}
			>
				{el.value ? el.value : 0}
			</span>
		));
		return result;
	};

	return (
		<>
			{active && payload && payload.length && (
				<div className="custom-tooltip">
					<h5 className="value">{getVaues(payload)}</h5>
					<ul className="custom-tooltip-item-list">
						<li className="date">{label}</li>
						<li className="phase">{getPhase(label)}</li>
					</ul>
				</div>
			)}
		</>
	);
};

export default CustomTooltip;
